module.exports = __webpack_public_path__ + "static/media/inkk-logo_en.b534b350.png";